import type { Baseline } from '@shared/models/project.model';

/**
 * Removes a {@link IProposal} from {@link Baseline.proposals} and drops any
 * actions that are no longer referenced by any remaining proposal (orphans).
 * Returns the same reference when the proposal is not found.
 */
export const deleteProposal = (
  version: Baseline,
  proposalId: string,
): Baseline => {
  const proposals = version.proposals ?? [];
  if (proposals.length <= 1) return version;
  const nextProposals = proposals.filter((p) => p.id !== proposalId);
  if (nextProposals.length === proposals.length) return version;

  // Collect action ids still referenced by at least one remaining proposal
  const referencedActionIds = new Set<string>();
  for (const p of nextProposals) {
    for (const id of p.actionIds) {
      referencedActionIds.add(id);
    }
  }

  const actions = version.actions;
  const nextActions = actions?.filter((a) => referencedActionIds.has(a.id));

  return {
    ...version,
    proposals: nextProposals,
    actions: nextActions ?? [],
  };
};
